/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserPreferencesControllerGetUserPreferencesQueryResponse, UserPreferencesControllerGetUserPreferencesPathParams, UserPreferencesControllerGetUserPreferences400, UserPreferencesControllerGetUserPreferences401, UserPreferencesControllerGetUserPreferences403, UserPreferencesControllerGetUserPreferences404 } from "../../models/userPreferencesController/UserPreferencesControllerGetUserPreferences";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { userPreferencesControllerGetUserPreferences } from "../../clients/user-preferencesService/userPreferencesControllerGetUserPreferences";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const userPreferencesControllerGetUserPreferencesQueryKey = (id: UserPreferencesControllerGetUserPreferencesPathParams["id"]) => [{
  url: '/api/v1/user-preferences/:id',
  params: {
    id: id
  }
}] as const;
export type UserPreferencesControllerGetUserPreferencesQueryKey = ReturnType<typeof userPreferencesControllerGetUserPreferencesQueryKey>;
export function userPreferencesControllerGetUserPreferencesQueryOptions(id: UserPreferencesControllerGetUserPreferencesPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = userPreferencesControllerGetUserPreferencesQueryKey(id);
  return queryOptions<UserPreferencesControllerGetUserPreferencesQueryResponse, ResponseErrorConfig<UserPreferencesControllerGetUserPreferences400 | UserPreferencesControllerGetUserPreferences401 | UserPreferencesControllerGetUserPreferences403 | UserPreferencesControllerGetUserPreferences404>, UserPreferencesControllerGetUserPreferencesQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return userPreferencesControllerGetUserPreferences(id, config);
    }
  });
}

/**
 * @description Retrieves the user's preferences. Auto-creates preferences if they don't exist.
 * @summary Get user preferences
 * {@link /api/v1/user-preferences/:id}
 */
export function useUserPreferencesControllerGetUserPreferences<TData = UserPreferencesControllerGetUserPreferencesQueryResponse, TQueryData = UserPreferencesControllerGetUserPreferencesQueryResponse, TQueryKey extends QueryKey = UserPreferencesControllerGetUserPreferencesQueryKey>(id: UserPreferencesControllerGetUserPreferencesPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<UserPreferencesControllerGetUserPreferencesQueryResponse, ResponseErrorConfig<UserPreferencesControllerGetUserPreferences400 | UserPreferencesControllerGetUserPreferences401 | UserPreferencesControllerGetUserPreferences403 | UserPreferencesControllerGetUserPreferences404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userPreferencesControllerGetUserPreferencesQueryKey(id);
  const query = useQuery({
    ...userPreferencesControllerGetUserPreferencesQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UserPreferencesControllerGetUserPreferences400 | UserPreferencesControllerGetUserPreferences401 | UserPreferencesControllerGetUserPreferences403 | UserPreferencesControllerGetUserPreferences404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}